import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { navigation, publicLinks } from "@/data/siteData";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="shell">
        <div className="footer-top">
          <div>
            <div className="footer-brand">Ashwini Patil</div>
            <p className="footer-summary">Data · AI · the decisions that connect them</p>
          </div>
          <nav className="footer-nav" aria-label="Footer navigation" data-testid="footer-navigation">
            {navigation.map((item) => (
              <Link key={item.path} to={item.path} className="footer-link" data-testid={`footer-link-${item.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                {item.label}
              </Link>
            ))}
            <Link to="/articles" className="footer-link" data-testid="footer-link-articles">Articles</Link>
            <a href={publicLinks.linkedin} target="_blank" rel="noreferrer noopener" className="footer-link" data-testid="footer-link-linkedin" aria-label="Open Ashwini Patil on LinkedIn">LinkedIn <ArrowUpRight size={12} aria-hidden="true" /></a>
            <a href={`mailto:${publicLinks.email}`} className="footer-link" data-testid="footer-link-email">Email <ArrowUpRight size={12} aria-hidden="true" /></a>
          </nav>
        </div>
        <div className="footer-bottom">
          <div className="footer-meta">
            <span>© 2026 Ashwini Patil</span>
            <span>Research, practice, conversation</span>
          </div>
          <p className="footer-disclaimer">Views expressed on this website are personal and do not represent those of current or previous employers or affiliated organizations.</p>
        </div>
      </div>
    </footer>
  );
}
